import { render, staticRenderFns } from "./Step2.vue?vue&type=template&id=5338cf09&scoped=true&lang=pug&"
import script from "./Step2.vue?vue&type=script&lang=js&"
export * from "./Step2.vue?vue&type=script&lang=js&"
import style0 from "../Onboarding.scss?vue&type=style&index=0&id=5338cf09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5338cf09",
  null
  
)

export default component.exports